import { useSelector } from 'react-redux';
import { requestFailed } from 'redux-request-state/util/requestStateCheckers';
import { Link } from 'foundations-components/transitional/components/Link';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
// @ts-expect-error no declarations found for module
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import AddPanelExpandableSection from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/AddPanelExpandableSections';
import TilesSectionSkeleton from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/TilesSectionSkeleton';
import RenderModules from 'LayoutBuilderUI/components/panels/sidebar/reusableHelpers/RenderModules';
// @ts-expect-error Cannot find declaration for module
import { fetchCustomModules } from 'LayoutBuilderUI/actions/ApiActions';
import { getSortedAndFilteredCustomModules } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { requestCompleted } from 'redux-request-state/util/requestStateCheckers';
import { getModuleSchemasRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
// @ts-expect-error Cannot find declaration for module
import { getAppDomain } from 'ContentEditorUI/utils/routeHelper';
import EmptyCustomSectionColumn from 'ContentEditorUI/components/sections/EmptyCustomSectionColumn';
import { designManager } from 'ContentUtils/Routes';
import { getModulesSearchTerm } from 'EmailEditorUI/redux/selectors/selected';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CustomModulesSection = () => {
  var _sortedSpecs$length;
  const searchTerm = useSelector(getModulesSearchTerm);
  const modulesRequest = useSelector(getModuleSchemasRequest);
  const appDomain = useSelector(getAppDomain);
  const sortedSpecs = useSelector(getSortedAndFilteredCustomModules);
  const showFailure = requestFailed(modulesRequest);
  const designManagerLink = `${appDomain}${designManager()}`;
  const sortedSpecsLength = (_sortedSpecs$length = sortedSpecs === null || sortedSpecs === void 0 ? void 0 : sortedSpecs.length) !== null && _sortedSpecs$length !== void 0 ? _sortedSpecs$length : 0;
  let content;
  if (!requestCompleted(modulesRequest)) {
    content = /*#__PURE__*/_jsx(TilesSectionSkeleton, {});
  } else if (showFailure) {
    content = /*#__PURE__*/_jsx(Alert, {
      "data-test-id": "custom-modules-area",
      type: "danger",
      marginInlineEnd: "600",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "layoutBuilder.addPanel.otherModules.errorFetching_jsx",
        elements: {
          Link
        },
        options: {
          onClick: fetchCustomModules
        }
      })
    });
  } else if (sortedSpecs.length === 0 && !searchTerm) {
    content = /*#__PURE__*/_jsx(EmptyCustomSectionColumn, {
      title: "layoutBuilder.addPanel.emptyState.customModules.title",
      message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "layoutBuilder.addPanel.emptyState.customModules.message_jsx",
        elements: {
          KnowledgeBaseButton,
          Link
        },
        options: {
          href: designManagerLink,
          url: 'https://knowledge.hubspot.com/design-manager/create-and-edit-modules'
        }
      })
    });
  } else if (sortedSpecs.length === 0 && searchTerm) {
    content = /*#__PURE__*/_jsx(_Fragment, {});
  } else {
    content = /*#__PURE__*/_jsx(RenderModules, {
      modules: sortedSpecs,
      withStoringInRecentlyUsed: true,
      isCustom: true
    });
  }
  return /*#__PURE__*/_jsx(AddPanelExpandableSection, {
    name: "custom-modules-section",
    "data-test-id": "custom-modules-section",
    disabled: sortedSpecsLength === 0,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "layoutBuilder.addPanel.otherModules.customModulesWithCount",
      options: {
        numberOfModules: sortedSpecsLength
      }
    }),
    actions: /*#__PURE__*/_jsx(Link, {
      external: true,
      href: designManagerLink,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "layoutBuilder.addPanel.otherModules.designManagerLinkText"
      })
    }),
    indentation: "compact",
    children: content
  });
};
export default CustomModulesSection;